import { styled, Typography } from "@mui/material";

export const ClubGiftContainer = styled("div")<{ background: string }>`
	background-image: url(${(props) => props.background});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;

	@media (orientation: landscape) {
		margin-right: 41px;
	}
	@media (orientation: portrait) {
		margin-top: 140px;
		width: 90%;
	}

	.item-container {
		position: relative;
		backdrop-filter: blur(14px);
		background: rgba(0, 0, 0, 0.25);
		border-radius: 16px;
		padding: 8px 16px;

		&.large {
			width: 447px;
			height: 113px;

			@media (orientation: portrait) {
				width: 100%;
				height: 92px;
			}
		}
		&.small {
			width: 447px;
			height: 67px;

			@media (orientation: portrait) {
				width: 100%;
				height: 60px;
			}
		}

		img {
			max-width: 65px;
			max-height: 65px;

			@media (orientation: portrait) {
				max-width: 55px;
				max-height: 55px;
			}

			:last-child {
				max-width: 50px;
				max-height: 50px;

				@media (orientation: portrait) {
					max-width: 40px;
					max-height: 40px;
				}
			}
		}
	}

	button {
		width: 90%;
		position: absolute;
		bottom: 26px;
		left: 50%;
		height: 58px;
		transform: translateX(-50%);
		font-size: 20px;

		@media (orientation: landscape) {
			width: 273px;
		}
	}
`;

export const Title = styled("img")`
	width: 100%;
	height: auto;
`;

export const Text = styled(Typography)<{
	type?: "primary" | "secondary";
	fontSize?: string;
	color?: string;
}>`
	color: ${(props) => props.color || "white"};
	font-size: ${(props) => props.fontSize || "21px"};
	line-height: 120%;
	${({ type }) => {
		if (type === "primary") {
			return `
				font-family: "Baloo";
				text-shadow: 2.08px 2.08px 0px #000;
				-webkit-text-stroke-width: 2.08px;
				-webkit-text-stroke-color: #000;
			`;
		}
	}}
`;
